var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import { List } from 'react-admin';
import { Box, useMediaQuery } from '@mui/material';
import { TimelineList } from '../Timeline';
import { EventListFilter } from './EventListFilter';
import { EventFilterAside } from './EventFilterAside';
import { EventDatagrid } from './EventDatagrid';
/**
 * A pre-configured List for event logs. Provides adequate views and filters.
 * @param props
 */
export var EventList = function (props) {
    var authorResource = props.authorResource, dateFilters = props.dateFilters, eventResource = props.eventResource, rest = __rest(props, ["authorResource", "dateFilters", "eventResource"]);
    var isSmall = useMediaQuery(function (theme) { return theme.breakpoints.down('sm'); });
    return (React.createElement(List, __assign({ component: isSmall ? EventListSmallContent : undefined, bulkActionButtons: false, sort: { field: 'date', order: 'DESC' }, aside: isSmall ? undefined : (React.createElement(EventFilterAside, { authorResource: authorResource, dateFilters: dateFilters, eventResource: eventResource })), filters: isSmall ? (React.createElement(EventListFilter, { authorResource: authorResource, dateFilters: dateFilters, eventResource: eventResource })) : undefined }, rest), isSmall ? (React.createElement(TimelineList, null)) : (React.createElement(EventDatagrid, { authorResource: authorResource }))));
};
export var EventListSmallContent = function (props) {
    return (React.createElement(Box, __assign({}, props, { sx: {
            display: 'flex',
            flexDirection: 'column',
            px: 0.5,
            width: '100%',
        } })));
};
